module.exports = __webpack_public_path__ + "static/media/image (35).e26ed00a.jpg";